module.exports = __webpack_public_path__ + "static/media/ex9.ef096d3d.jpg";